module.exports = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 178,
	"w": 566,
	"h": 340,
	"nm": "OneLineOfCode",
	"ddd": 0,
	"assets": [],
	"fonts": {
		"list": [
			{
				"fName": "ABCMonumentGroteskSemi-Mono-Regular",
				"fFamily": "ABC Monument Grotesk Semi-Mono",
				"fStyle": "Regular",
				"ascent": 69.9996948242188
			}
		]
	},
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 5,
			"nm": "<one_line_of_code>",
			"tg": "one_line_of_code",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						203.189,
						183,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"t": {
				"d": {
					"k": [
						{
							"s": {
								"s": 16,
								"f": "ABCMonumentGroteskSemi-Mono-Regular",
								"t": "<one_line_of_code>",
								"j": 0,
								"tr": 0,
								"lh": 19.2,
								"ls": 0,
								"fc": [
									0,
									0.275,
									1
								]
							},
							"t": 0
						}
					]
				},
				"p": {},
				"m": {
					"g": 1,
					"a": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 2
					}
				},
				"a": [
					{
						"nm": "Animator 1",
						"s": {
							"t": 0,
							"xe": {
								"a": 0,
								"k": 0,
								"ix": 7
							},
							"ne": {
								"a": 0,
								"k": 0,
								"ix": 8
							},
							"a": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"b": 1,
							"rn": 0,
							"sh": 1,
							"s": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 0,
										"s": [
											100
										]
									},
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 111,
										"s": [
											100
										]
									},
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 112,
										"s": [
											0
										]
									},
									{
										"t": 170,
										"s": [
											100
										]
									}
								],
								"ix": 1
							},
							"e": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 0,
										"s": [
											0
										]
									},
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 56,
										"s": [
											100
										]
									},
									{
										"i": {
											"x": [
												0.833
											],
											"y": [
												0.833
											]
										},
										"o": {
											"x": [
												0.167
											],
											"y": [
												0.167
											]
										},
										"t": 111,
										"s": [
											100
										]
									},
									{
										"t": 112,
										"s": [
											0
										]
									}
								],
								"ix": 2
							},
							"r": 1
						},
						"a": {
							"o": {
								"a": 0,
								"k": 0,
								"ix": 9
							}
						}
					}
				]
			},
			"ip": 0,
			"op": 178,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "OneLineOfCode Outlines",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						283,
						171,
						0
					],
					"ix": 2,
					"l": 2
				},
				"a": {
					"a": 0,
					"k": [
						282,
						170,
						0
					],
					"ix": 1,
					"l": 2
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6,
					"l": 2
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											6.627,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-6.627
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-6.627,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-6.627
										]
									],
									"v": [
										[
											269.5,
											-169
										],
										[
											-269.5,
											-169
										],
										[
											-281.5,
											-157
										],
										[
											-281.5,
											169
										],
										[
											281.5,
											169
										],
										[
											281.5,
											-157
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0.945098099054,
									0.937254961799,
									0.89019613827,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 1,
								"ix": 5
							},
							"lc": 1,
							"lj": 1,
							"ml": 10,
							"bm": 0,
							"nm": "Stroke 2",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									282,
									169
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											-2.761
										],
										[
											-2.762,
											0
										],
										[
											0,
											2.761
										],
										[
											2.762,
											0
										]
									],
									"o": [
										[
											0,
											2.761
										],
										[
											2.762,
											0
										],
										[
											0,
											-2.761
										],
										[
											-2.762,
											0
										]
									],
									"v": [
										[
											-5,
											0
										],
										[
											0,
											5
										],
										[
											5,
											0
										],
										[
											0,
											-5
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									45.5,
									12.5
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 2",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-2.761,
											0
										],
										[
											0,
											2.761
										],
										[
											2.761,
											0
										],
										[
											0,
											-2.761
										]
									],
									"o": [
										[
											2.761,
											0
										],
										[
											0,
											-2.761
										],
										[
											-2.761,
											0
										],
										[
											0,
											2.761
										]
									],
									"v": [
										[
											0,
											5
										],
										[
											5,
											0
										],
										[
											0,
											-5
										],
										[
											-5,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									45.5,
									12.5
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 3",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											-2.761
										],
										[
											-2.761,
											0
										],
										[
											0,
											2.761
										],
										[
											2.761,
											0
										]
									],
									"o": [
										[
											0,
											2.761
										],
										[
											2.761,
											0
										],
										[
											0,
											-2.761
										],
										[
											-2.761,
											0
										]
									],
									"v": [
										[
											-5,
											0
										],
										[
											0,
											5
										],
										[
											5,
											0
										],
										[
											0,
											-5
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									30.5,
									12.5
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 4",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 4,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-2.761,
											0
										],
										[
											0,
											2.761
										],
										[
											2.761,
											0
										],
										[
											0,
											-2.761
										]
									],
									"o": [
										[
											2.761,
											0
										],
										[
											0,
											-2.761
										],
										[
											-2.761,
											0
										],
										[
											0,
											2.761
										]
									],
									"v": [
										[
											0,
											5
										],
										[
											5,
											0
										],
										[
											0,
											-5
										],
										[
											-5,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									30.5,
									12.5
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 5",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 5,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											-2.761
										],
										[
											-2.762,
											0
										],
										[
											0,
											2.761
										],
										[
											2.762,
											0
										]
									],
									"o": [
										[
											0,
											2.761
										],
										[
											2.762,
											0
										],
										[
											0,
											-2.761
										],
										[
											-2.762,
											0
										]
									],
									"v": [
										[
											-5,
											0
										],
										[
											0,
											5
										],
										[
											5,
											0
										],
										[
											0,
											-5
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									16.5,
									12.5
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 6",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 6,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-2.761,
											0
										],
										[
											0,
											2.761
										],
										[
											2.761,
											0
										],
										[
											0,
											-2.761
										]
									],
									"o": [
										[
											2.761,
											0
										],
										[
											0,
											-2.761
										],
										[
											-2.761,
											0
										],
										[
											0,
											2.761
										]
									],
									"v": [
										[
											0,
											5
										],
										[
											5,
											0
										],
										[
											0,
											-5
										],
										[
											-5,
											0
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									16.5,
									12.5
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 7",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 7,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.28,
											-0.463
										],
										[
											0,
											-0.35
										],
										[
											0,
											0
										],
										[
											0.225,
											0.336
										],
										[
											0.756,
											0
										]
									],
									"o": [
										[
											-0.252,
											0.42
										],
										[
											0,
											0
										],
										[
											-0.014,
											-0.378
										],
										[
											-0.364,
											-0.532
										],
										[
											-0.784,
											0
										]
									],
									"v": [
										[
											-1.646,
											-1.891
										],
										[
											-1.982,
											-0.645
										],
										[
											2.024,
											-0.645
										],
										[
											1.646,
											-1.891
										],
										[
											0.007,
											-2.648
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0.056,
											-0.995
										],
										[
											0,
											0
										],
										[
											-1.317,
											0
										],
										[
											-0.169,
											1.065
										],
										[
											0,
											0
										],
										[
											1.779,
											0
										],
										[
											0.602,
											0.7
										],
										[
											0,
											1.093
										],
										[
											-0.589,
											0.659
										],
										[
											-1.008,
											0
										],
										[
											-0.574,
											-0.91
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0.028,
											1.541
										],
										[
											1.191,
											0
										],
										[
											0,
											0
										],
										[
											-0.308,
											1.64
										],
										[
											-1.079,
											0
										],
										[
											-0.589,
											-0.658
										],
										[
											0,
											-1.037
										],
										[
											0.616,
											-0.7
										],
										[
											1.107,
											0
										],
										[
											0.421,
											0.673
										]
									],
									"v": [
										[
											3.313,
											0.378
										],
										[
											-1.996,
											0.378
										],
										[
											-0.007,
											2.661
										],
										[
											1.997,
											1.092
										],
										[
											3.215,
											1.19
										],
										[
											0.007,
											3.67
										],
										[
											-2.514,
											2.647
										],
										[
											-3.369,
											-0.014
										],
										[
											-2.486,
											-2.62
										],
										[
											-0.007,
											-3.67
										],
										[
											2.724,
											-2.284
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									305.332,
									12.999
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 8",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 8,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											1.134
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.519,
											0
										],
										[
											-0.238,
											0.042
										],
										[
											0,
											0
										],
										[
											0.252,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0.463
										],
										[
											0.154,
											0
										],
										[
											0,
											0
										],
										[
											-0.224,
											0.042
										],
										[
											-1.303,
											0
										]
									],
									"v": [
										[
											-0.833,
											2.872
										],
										[
											-0.833,
											-1.513
										],
										[
											-1.842,
											-1.513
										],
										[
											-1.842,
											-2.564
										],
										[
											-0.833,
											-2.564
										],
										[
											-0.833,
											-4.511
										],
										[
											0.413,
											-4.511
										],
										[
											0.413,
											-2.564
										],
										[
											1.842,
											-2.564
										],
										[
											1.842,
											-1.513
										],
										[
											0.413,
											-1.513
										],
										[
											0.413,
											2.829
										],
										[
											1.142,
											3.376
										],
										[
											1.786,
											3.306
										],
										[
											1.814,
											4.44
										],
										[
											1.044,
											4.511
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									299.297,
									12.06
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 9",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 9,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-0.63,
											-2.101
										],
										[
											0.63,
											-2.101
										],
										[
											0.63,
											4.903
										],
										[
											-0.63,
											4.903
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										]
									],
									"v": [
										[
											-0.63,
											4.903
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 2,
							"ty": "sh",
							"ix": 3,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-0.63,
											-4.903
										],
										[
											0.63,
											-4.903
										],
										[
											0.63,
											-3.418
										],
										[
											-0.63,
											-3.418
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 3",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									295.594,
									11.597
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 10",
					"np": 5,
					"cix": 2,
					"bm": 0,
					"ix": 10,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.014,
											1.736
										],
										[
											0,
											0
										],
										[
											-1.092,
											0
										],
										[
											0,
											0.742
										],
										[
											0.967,
											0.251
										],
										[
											0,
											1.387
										],
										[
											-1.246,
											0
										],
										[
											-0.154,
											-1.709
										],
										[
											0,
											0
										],
										[
											1.107,
											0
										],
										[
											0,
											-0.645
										],
										[
											-0.841,
											-0.183
										],
										[
											0,
											-1.639
										],
										[
											1.415,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-0.013,
											0.98
										],
										[
											1.149,
											0
										],
										[
											0,
											-0.799
										],
										[
											-1.135,
											-0.295
										],
										[
											0,
											-1.457
										],
										[
											1.485,
											0
										],
										[
											0,
											0
										],
										[
											-0.027,
											-0.966
										],
										[
											-0.686,
											0
										],
										[
											0,
											0.644
										],
										[
											1.4,
											0.294
										],
										[
											0,
											1.709
										],
										[
											-1.57,
											0
										]
									],
									"v": [
										[
											-2.921,
											1.205
										],
										[
											-1.772,
											1.093
										],
										[
											0.021,
											2.676
										],
										[
											1.743,
											1.541
										],
										[
											-0.512,
											0.393
										],
										[
											-2.767,
											-1.625
										],
										[
											-0.176,
											-3.67
										],
										[
											2.753,
											-1.373
										],
										[
											1.576,
											-1.191
										],
										[
											-0.19,
											-2.676
										],
										[
											-1.59,
											-1.709
										],
										[
											0.091,
											-0.7
										],
										[
											2.935,
											1.471
										],
										[
											0.049,
											3.67
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									290.618,
									12.998
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 11",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 11,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.099,
											0
										],
										[
											0,
											0
										],
										[
											0.126,
											0
										],
										[
											0,
											-2.256
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-1.148,
											0.084
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-0.084,
											-0.013
										],
										[
											-1.33,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.196,
											-0.671
										],
										[
											0.113,
											-0.014
										]
									],
									"v": [
										[
											1.954,
											-3.586
										],
										[
											1.926,
											-2.396
										],
										[
											1.603,
											-2.409
										],
										[
											-0.693,
											0.267
										],
										[
											-0.693,
											3.586
										],
										[
											-1.954,
											3.586
										],
										[
											-1.954,
											-3.418
										],
										[
											-0.693,
											-3.418
										],
										[
											-0.693,
											-2.186
										],
										[
											1.477,
											-3.572
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									282.022,
									12.914
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 12",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 12,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.995,
											0
										],
										[
											0.504,
											0.532
										],
										[
											0,
											0.743
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.421,
											-0.406
										],
										[
											-0.406,
											0
										],
										[
											0,
											2.031
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.378,
											0.799
										],
										[
											-0.91,
											0
										],
										[
											-0.546,
											-0.575
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0.645
										],
										[
											0.406,
											0.392
										],
										[
											0.63,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											1.765,
											-3.586
										],
										[
											3.026,
											-3.586
										],
										[
											3.026,
											3.418
										],
										[
											1.765,
											3.418
										],
										[
											1.765,
											2.367
										],
										[
											-0.392,
											3.586
										],
										[
											-2.465,
											2.802
										],
										[
											-3.025,
											0.602
										],
										[
											-3.025,
											-3.586
										],
										[
											-1.722,
											-3.586
										],
										[
											-1.722,
											0.532
										],
										[
											-1.316,
											2.129
										],
										[
											-0.042,
											2.535
										],
										[
											1.765,
											0.351
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									275.198,
									13.082
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 13",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 13,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-0.336,
											0.379
										],
										[
											0,
											0.91
										],
										[
											0.42,
											0.462
										],
										[
											0.715,
											0
										],
										[
											0.336,
											-0.35
										],
										[
											0,
											-0.938
										],
										[
											-0.448,
											-0.463
										],
										[
											-0.7,
											0
										]
									],
									"o": [
										[
											0.406,
											-0.462
										],
										[
											0,
											-0.91
										],
										[
											-0.336,
											-0.364
										],
										[
											-0.686,
											0
										],
										[
											-0.448,
											0.462
										],
										[
											0,
											0.939
										],
										[
											0.336,
											0.349
										],
										[
											0.715,
											0
										]
									],
									"v": [
										[
											1.562,
											2.087
										],
										[
											2.136,
											0
										],
										[
											1.548,
											-2.101
										],
										[
											0.007,
											-2.676
										],
										[
											-1.52,
											-2.143
										],
										[
											-2.136,
											0
										],
										[
											-1.52,
											2.144
										],
										[
											0.007,
											2.676
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ind": 1,
							"ty": "sh",
							"ix": 2,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											2.283
										],
										[
											-2.171,
											0
										],
										[
											0,
											-2.115
										],
										[
											2.101,
											0
										]
									],
									"o": [
										[
											0,
											-2.129
										],
										[
											2.143,
											0
										],
										[
											0,
											2.199
										],
										[
											-2.185,
											0
										]
									],
									"v": [
										[
											-3.495,
											0
										],
										[
											0.007,
											-3.67
										],
										[
											3.495,
											0
										],
										[
											0.007,
											3.67
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 2",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "mm",
							"mm": 1,
							"nm": "Merge Paths 1",
							"mn": "ADBE Vector Filter - Merge",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									267.323,
									12.998
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 14",
					"np": 4,
					"cix": 2,
					"bm": 0,
					"ix": 14,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-0.364,
											-0.658
										],
										[
											-0.308,
											0.532
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0.099,
											0.168
										],
										[
											0.407,
											-0.728
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-0.637,
											4.903
										],
										[
											-0.637,
											0.715
										],
										[
											-4.153,
											-4.903
										],
										[
											-2.682,
											-4.903
										],
										[
											-1.03,
											-2.101
										],
										[
											-0.007,
											-0.294
										],
										[
											1.016,
											-2.101
										],
										[
											2.669,
											-4.903
										],
										[
											4.154,
											-4.903
										],
										[
											0.637,
											0.715
										],
										[
											0.637,
											4.903
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.129411764706,
									0.129411764706,
									0.129411764706,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									259.092,
									11.597
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 15",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 15,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											-6.628
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											6.628,
											0
										]
									],
									"o": [
										[
											-6.628,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-6.628
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-269.5,
											-12
										],
										[
											-281.5,
											0
										],
										[
											-281.5,
											12
										],
										[
											281.5,
											12
										],
										[
											281.5,
											0
										],
										[
											269.5,
											-12
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0.945098099054,
									0.937254961799,
									0.89019613827,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									282,
									12.5
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 16",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 16,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 178,
			"st": 0,
			"bm": 0
		}
	],
	"markers": [],
	"chars": [
		{
			"ch": "<",
			"size": 16,
			"style": "Regular",
			"w": 55.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												4.431,
												1.41
											],
											[
												-2.719,
												1.108
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												-2.417,
												-1.007
											],
											[
												4.33,
												-1.41
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												47.333,
												-16.818
											],
											[
												25.781,
												-25.58
											],
											[
												13.696,
												-29.81
											],
											[
												25.882,
												-34.039
											],
											[
												47.333,
												-42.801
											],
											[
												47.333,
												-50.757
											],
											[
												7.15,
												-33.737
											],
											[
												7.15,
												-25.882
											],
											[
												47.333,
												-8.862
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "<",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "<",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "o",
			"size": 16,
			"style": "Regular",
			"w": 59.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.71,
												0
											],
											[
												0,
												15.811
											],
											[
												15.408,
												0
											],
											[
												0,
												-15.308
											]
										],
										"o": [
											[
												15.106,
												0
											],
											[
												0,
												-15.207
											],
											[
												-15.61,
												0
											],
											[
												0,
												16.415
											]
										],
										"v": [
											[
												30.112,
												1.208
											],
											[
												55.188,
												-25.177
											],
											[
												30.112,
												-51.562
											],
											[
												4.935,
												-25.177
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "o",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												5.136,
												0
											],
											[
												2.417,
												2.518
											],
											[
												0,
												6.747
											],
											[
												-3.223,
												3.323
											],
											[
												-4.935,
												0
											],
											[
												-2.417,
												-2.618
											],
											[
												0,
												-6.546
											],
											[
												2.921,
												-3.323
											]
										],
										"o": [
											[
												-5.035,
												0
											],
											[
												-3.223,
												-3.323
											],
											[
												0,
												-6.747
											],
											[
												2.417,
												-2.518
											],
											[
												5.136,
												0
											],
											[
												3.021,
												3.323
											],
											[
												0,
												6.546
											],
											[
												-2.417,
												2.719
											]
										],
										"v": [
											[
												30.112,
												-5.942
											],
											[
												19.135,
												-9.769
											],
											[
												14.703,
												-25.177
											],
											[
												19.135,
												-40.585
											],
											[
												30.112,
												-44.412
											],
											[
												41.19,
												-40.283
											],
											[
												45.419,
												-25.177
											],
											[
												41.29,
												-10.172
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "o",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "o",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "n",
			"size": 16,
			"style": "Regular",
			"w": 59,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.928,
												4.129
											],
											[
												6.647,
												0
											],
											[
												2.518,
												-5.64
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-4.431,
												0
											],
											[
												-2.82,
												-2.82
											],
											[
												0,
												-4.633
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-3.625,
												-3.827
											],
											[
												-8.057,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-14.401
											],
											[
												2.82,
												0
											],
											[
												3.122,
												2.921
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-4.935
											]
										],
										"v": [
											[
												47.937,
												-45.923
											],
											[
												32.932,
												-51.562
											],
											[
												17.422,
												-42.7
											],
											[
												17.422,
												-50.354
											],
											[
												8.359,
												-50.354
											],
											[
												8.359,
												0
											],
											[
												17.422,
												0
											],
											[
												17.422,
												-27.795
											],
											[
												30.515,
												-44.009
											],
											[
												39.478,
												-41.089
											],
											[
												42.499,
												-29.407
											],
											[
												42.499,
												0
											],
											[
												51.865,
												0
											],
											[
												51.865,
												-29.91
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "n",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "n",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "e",
			"size": 16,
			"style": "Regular",
			"w": 58.5,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												3.021,
												4.834
											],
											[
												7.956,
												0
											],
											[
												4.431,
												-5.035
											],
											[
												0,
												-7.452
											],
											[
												-4.23,
												-4.733
											],
											[
												-7.755,
												0
											],
											[
												-2.216,
												11.783
											],
											[
												0,
												0
											],
											[
												8.56,
												0
											],
											[
												0.201,
												11.078
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-4.129,
												-6.546
											],
											[
												-7.251,
												0
											],
											[
												-4.23,
												4.733
											],
											[
												0,
												7.855
											],
											[
												4.33,
												5.035
											],
											[
												12.79,
												0
											],
											[
												0,
												0
											],
											[
												-1.208,
												7.654
											],
											[
												-9.467,
												0
											],
											[
												0,
												0
											],
											[
												0.403,
												-7.15
											]
										],
										"v": [
											[
												49.347,
												-41.592
											],
											[
												29.709,
												-51.562
											],
											[
												11.884,
												-44.009
											],
											[
												5.539,
												-25.278
											],
											[
												11.682,
												-6.143
											],
											[
												29.81,
												1.208
											],
											[
												52.872,
												-16.617
											],
											[
												44.11,
												-17.322
											],
											[
												29.709,
												-6.042
											],
											[
												15.408,
												-22.458
											],
											[
												53.577,
												-22.458
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "e",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-5.64,
												0
											],
											[
												-2.618,
												-3.827
											],
											[
												-0.101,
												-2.719
											],
											[
												0,
												0
											],
											[
												-1.813,
												3.021
											]
										],
										"o": [
											[
												5.438,
												0
											],
											[
												1.611,
												2.417
											],
											[
												0,
												0
											],
											[
												0,
												-2.518
											],
											[
												2.014,
												-3.323
											]
										],
										"v": [
											[
												29.81,
												-44.211
											],
											[
												41.592,
												-38.773
											],
											[
												44.312,
												-29.81
											],
											[
												15.509,
												-29.81
											],
											[
												17.926,
												-38.773
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "e",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "e",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "_",
			"size": 16,
			"style": "Regular",
			"w": 53.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												50.455,
												13.696
											],
											[
												50.455,
												6.647
											],
											[
												3.525,
												6.647
											],
											[
												3.525,
												13.696
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "_",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "_",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "l",
			"size": 16,
			"style": "Regular",
			"w": 42.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.486,
												-70.496
											],
											[
												9.064,
												-70.496
											],
											[
												9.064,
												-62.842
											],
											[
												17.422,
												-62.842
											],
											[
												17.422,
												-7.654
											],
											[
												7.352,
												-7.654
											],
											[
												7.352,
												0
											],
											[
												35.651,
												0
											],
											[
												35.651,
												-7.654
											],
											[
												26.486,
												-7.654
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "l",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "l",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "i",
			"size": 16,
			"style": "Regular",
			"w": 42.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												16.617,
												-70.596
											],
											[
												16.617,
												-59.72
											],
											[
												25.882,
												-59.72
											],
											[
												25.882,
												-70.596
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "i",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.285,
												-50.354
											],
											[
												8.661,
												-50.354
											],
											[
												8.661,
												-42.7
											],
											[
												17.221,
												-42.7
											],
											[
												17.221,
												-7.654
											],
											[
												7.15,
												-7.654
											],
											[
												7.15,
												0
											],
											[
												35.449,
												0
											],
											[
												35.449,
												-7.654
											],
											[
												26.285,
												-7.654
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "i",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "i",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "f",
			"size": 16,
			"style": "Regular",
			"w": 46,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-5.035,
												0
											],
											[
												-1.913,
												-0.403
											],
											[
												0,
												0
											],
											[
												2.82,
												0
											],
											[
												0,
												-8.157
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												-3.323
											],
											[
												1.913,
												0
											],
											[
												0,
												0
											],
											[
												-1.309,
												-0.302
											],
											[
												-10.977,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												26.385,
												0
											],
											[
												26.385,
												-42.801
											],
											[
												40.686,
												-42.801
											],
											[
												40.686,
												-50.354
											],
											[
												26.385,
												-50.354
											],
											[
												26.385,
												-58.713
											],
											[
												33.636,
												-62.943
											],
											[
												39.981,
												-62.338
											],
											[
												40.182,
												-70.395
											],
											[
												33.133,
												-70.999
											],
											[
												17.422,
												-58.914
											],
											[
												17.422,
												-50.354
											],
											[
												6.848,
												-50.354
											],
											[
												6.848,
												-42.801
											],
											[
												17.422,
												-42.801
											],
											[
												17.422,
												0
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "f",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "f",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "c",
			"size": 16,
			"style": "Regular",
			"w": 57.6,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												-15.408,
												0
											],
											[
												-1.813,
												10.172
											],
											[
												0,
												0
											],
											[
												7.755,
												0
											],
											[
												0,
												11.38
											],
											[
												-2.518,
												3.424
											],
											[
												-5.74,
												0
											],
											[
												-1.511,
												-5.841
											],
											[
												0,
												0
											],
											[
												12.79,
												0
											],
											[
												0,
												-15.509
											]
										],
										"o": [
											[
												11.682,
												0
											],
											[
												0,
												0
											],
											[
												-1.913,
												7.251
											],
											[
												-12.186,
												0
											],
											[
												0,
												-5.942
											],
											[
												2.316,
												-3.021
											],
											[
												9.064,
												0
											],
											[
												0,
												0
											],
											[
												-2.014,
												-9.567
											],
											[
												-15.408,
												0
											],
											[
												0,
												16.516
											]
										],
										"v": [
											[
												30.917,
												1.208
											],
											[
												53.174,
												-15.408
											],
											[
												44.614,
												-16.315
											],
											[
												30.917,
												-6.042
											],
											[
												15.912,
												-25.177
											],
											[
												19.235,
												-39.578
											],
											[
												30.917,
												-44.312
											],
											[
												44.513,
												-32.73
											],
											[
												52.972,
												-34.341
											],
											[
												30.917,
												-51.562
											],
											[
												5.942,
												-25.177
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "c",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "c",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": "d",
			"size": 16,
			"style": "Regular",
			"w": 60.1,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												7.05,
												0
											],
											[
												0,
												-15.912
											],
											[
												-13.394,
												0
											],
											[
												-3.726,
												5.74
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												-3.827,
												-5.338
											],
											[
												-13.596,
												0
											],
											[
												0,
												16.415
											],
											[
												6.747,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												43.607,
												-43.808
											],
											[
												27.393,
												-51.562
											],
											[
												4.532,
												-25.177
											],
											[
												27.695,
												1.208
											],
											[
												43.607,
												-7.352
											],
											[
												43.607,
												0
											],
											[
												52.67,
												0
											],
											[
												52.67,
												-70.496
											],
											[
												43.607,
												-70.496
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "d",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							},
							{
								"ind": 1,
								"ty": "sh",
								"ix": 2,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												2.82,
												-3.223
											],
											[
												4.431,
												0
											],
											[
												0,
												11.783
											],
											[
												-2.518,
												3.323
											],
											[
												-5.64,
												0
											],
											[
												0,
												-9.366
											]
										],
										"o": [
											[
												-2.417,
												2.719
											],
											[
												-11.783,
												0
											],
											[
												0,
												-6.143
											],
											[
												2.316,
												-3.122
											],
											[
												12.286,
												0
											],
											[
												0,
												6.747
											]
										],
										"v": [
											[
												39.578,
												-10.071
											],
											[
												29.306,
												-5.942
											],
											[
												14.502,
												-25.177
											],
											[
												17.926,
												-39.478
											],
											[
												29.507,
												-44.312
											],
											[
												43.909,
												-25.076
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": "d",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": "d",
						"np": 5,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		},
		{
			"ch": ">",
			"size": 16,
			"style": "Regular",
			"w": 55.3,
			"data": {
				"shapes": [
					{
						"ty": "gr",
						"it": [
							{
								"ind": 0,
								"ty": "sh",
								"ix": 1,
								"ks": {
									"a": 0,
									"k": {
										"i": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												-4.33,
												-1.41
											],
											[
												2.417,
												-1.007
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"o": [
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												2.719,
												1.108
											],
											[
												-4.431,
												1.41
											],
											[
												0,
												0
											],
											[
												0,
												0
											],
											[
												0,
												0
											]
										],
										"v": [
											[
												48.541,
												-25.882
											],
											[
												48.541,
												-33.737
											],
											[
												8.359,
												-50.757
											],
											[
												8.359,
												-42.801
											],
											[
												29.81,
												-34.039
											],
											[
												41.995,
												-29.81
											],
											[
												29.91,
												-25.58
											],
											[
												8.359,
												-16.818
											],
											[
												8.359,
												-8.862
											]
										],
										"c": true
									},
									"ix": 2
								},
								"nm": ">",
								"mn": "ADBE Vector Shape - Group",
								"hd": false
							}
						],
						"nm": ">",
						"np": 3,
						"cix": 2,
						"bm": 0,
						"ix": 1,
						"mn": "ADBE Vector Group",
						"hd": false
					}
				]
			},
			"fFamily": "ABC Monument Grotesk Semi-Mono"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./assets/animations/OneLineOfCode.json
// module id = 52
// module chunks = 0